import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function ApiKeyPage() {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const [webhookCopied, setWebhookCopied] = useState(false);
  const [alert, setAlert]   = useState(true);
  const [apiKey, setApiKey] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/api-keys")
      .then((res) => {
        const data = res.data?.data || res.data;
        const key = Array.isArray(data) ? data[0] : data;
        setApiKey(key || null);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const secretKey = apiKey?.api_key_display || apiKey?.api_key || "";
  const webhookSecret = apiKey?.webhook_secret || "";
  const keyId = apiKey?.api_key_id || "—";
  const createdAt = apiKey?.created_at ? new Date(apiKey.created_at).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
  const status    = apiKey?.status   || "active";
  const isActive  = status?.toLowerCase() === "active";
  const rateLimit = apiKey?.rate_limit ? `${apiKey.rate_limit} req/min` : "—";
  const usage     = apiKey?.usage_percent ?? 0;

  const handleCopy = () => {
    if (!secretKey) return;
    navigator.clipboard.writeText(secretKey);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleWebhookCopy = () => {
    if (!webhookSecret) return;
    navigator.clipboard.writeText(webhookSecret);
    setWebhookCopied(true);
    setTimeout(() => setWebhookCopied(false), 2000);
  };

  const handleRevoke = async () => {
    if (!apiKey?.api_key_id) return;
    if (!window.confirm("Are you sure you want to revoke this API key?")) return;
    try {
      const res = await api.patch(`/api-keys/${apiKey.api_key_id}/revoke`);
      const updated = res.data?.data;
      if (updated) setApiKey(updated);
    } catch {
      alert("Failed to revoke API key.");
    }
  };

  if (loading) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#4B2364] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
        <div className="flex-1 overflow-y-auto px-10 py-7">

                  {/* Active Alert */}
              {/* {alert && isActive && (
            <div className="flex items-center justify-between bg-[#F0FDF4] border border-[#BBF7D0] rounded-[12px] px-5 py-3.5 mb-6">
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full bg-[#DCFCE7] flex items-center justify-center shrink-0">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#16A34A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <p className="text-[13px] font-medium text-[#15803D]">Your API key is active and ready to use. Keep it secure — never expose it in client-side code.</p>
              </div>
              <button onClick={() => setAlert(false)} className="text-[#86EFAC] hover:text-[#16A34A] bg-transparent border-none cursor-pointer ml-4 shrink-0">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M6 18L18 6M6 6l12 12"/></svg>
              </button>
            </div>
          )} */}

          {/* Page Header */}
          <div className="mb-6 max-w-[598px]">
            <p className="text-[14px] font-bold text-[#64748B] uppercase tracking-wider">DEVELOPER RESOURCES</p>
            <h1 className="text-[40px] font-bold text-[#34094D]">My API Key</h1>
          </div>

          {/* Two Column */}
          <div className="grid gap-10 mb-6" style={{ gridTemplateColumns: "1fr 0.55fr" }}>

            {/* LEFT — API Key Card */}
            <div className="bg-white rounded-[24px] shadow-[0px_12px_40px_0px_#4B23640A] border border-[#CEC3D01A] p-7 flex flex-col gap-6">

              {/* Top */}
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-9 rounded-[10px] rotate-45 flex items-center justify-center">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#581C87" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/>
                    </svg>
                  </div>
                  <div>
                    <p className="text-[20px] font-bold text-[#191C1D]">Production Key</p>
                    <p className="text-[14px] font-regular text-[#4C444E] mt-0.5">Key ID: 
                      <span className="text-[12px] font-regular  text-[#4C444E]"> {keyId}</span></p>
                  </div>
                </div>
                <span className={`inline-flex items-center gap-1.5 text-[11px] font-bold px-3 py-1 rounded-full shrink-0 ${
                  isActive ? "text-[#16A34A] bg-[#DCFCE7]" : "text-[#DC2626] bg-[#FEE2E2]"
                }`}>
                  <span className={`w-1.5 h-1.5 rounded-full inline-block ${isActive ? "bg-[#16A34A]" : "bg-[#DC2626]"}`}/>
                  {status.toUpperCase()}
                </span>
              </div>

              {/* Secret Key */}
              <div>
                <p className="text-[12px] font-bold text-[#4C444E] uppercase tracking-widest mb-2">Secret API Key</p>
                <div className="flex items-center bg-[#F3F4F5] rounded-[16px] overflow-hidden">
                  <div className="w-1 self-stretch shrink-0" style={{ background: "linear-gradient(180deg, #EA8534 0%, #A0111A 100%)" }} />
                  <code className="flex-1 text-[18px] font-bold text-[#34094D] px-4 py-3.5 truncate">
                    {secretKey || "No API key found"}
                  </code>
                  <div className="flex items-center gap-1 pr-2">
                    {/* <button onClick={() => setShowKey(!showKey)} className="w-8 h-8 flex items-center justify-center rounded-[8px] text-[#9CA3AF] hover:text-[#6D28D9] hover:bg-white bg-transparent border-none cursor-pointer transition-colors">
                      {showKey ? (
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                      ) : (
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                      )}
                    </button> */}
                    <button onClick={handleCopy} className={`w-8 h-8 flex items-center justify-center rounded-[12px] border-none cursor-pointer transition-all ${copied ? "bg-emerald-100 text-emerald-600" : "bg-white shadow-[0px_1px_2px_0px_#0000000D] text-[#34094D] hover:text-[#6D28D9] shadow-sm"}`}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
                      </svg>
                    </button>
                  </div>
                </div>
                {copied && <p className="text-[11px] text-emerald-600 font-medium mt-1.5">✓ Copied to clipboard</p>}
              </div>

              {/* Webhook Secret */}
              <div>
                <p className="text-[12px] font-bold text-[#4C444E] uppercase tracking-widest mb-2">Webhook Secret</p>
                <div className="flex items-center bg-[#F3F4F5] rounded-[16px] overflow-hidden">
                  <div className="w-1 self-stretch shrink-0" style={{ background: "linear-gradient(180deg, #EA8534 0%, #A0111A 100%)" }} />
                  <code className="flex-1 text-[18px] font-bold text-[#34094D] px-4 py-3.5 truncate">
                    {webhookSecret || "No webhook secret found"}
                  </code>
                  <div className="flex items-center gap-1 pr-2">
                    <button onClick={handleWebhookCopy} className={`w-8 h-8 flex items-center justify-center rounded-[12px] border-none cursor-pointer transition-all ${webhookCopied ? "bg-emerald-100 text-emerald-600" : "bg-white shadow-[0px_1px_2px_0px_#0000000D] text-[#34094D] hover:text-[#6D28D9] shadow-sm"}`}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
                      </svg>
                    </button>
                  </div>
                </div>
                {webhookCopied && <p className="text-[11px] text-emerald-600 font-medium mt-1.5">✓ Copied to clipboard</p>}
              </div>

              <div className="border-t border-[#F3F4F6]" />

              {/* Info */}
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <p className="text-[12px] font-semibold text-[#4C444E] mb-1.5">Created At</p>
                  <p className="text-[16px] font-bold text-[#191C1D]">{createdAt}</p>
                </div>
                <div>
                  <p className="text-[12px] font-semibold text-[#4C444E] mb-1.5">Rate Limit</p>
                  <p className="text-[16px] font-bold text-[#191C1D]">{rateLimit}</p>
                </div>
              </div>

              {/* Buttons */}
              <div className="grid grid-cols-6 gap-4">
                {/* <button className="col-span-2 flex-1 bg-[#4B2364] flex items-center justify-center gap-2 text-[14px] font-semibold text-white py-2.5 rounded-[12px] border-none cursor-pointer hover:opacity-90 transition-all shadow-[0px_4px_12px_rgba(109,40,217,0.25)]">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><path d="M21 12a9 9 0 11-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>
                  Rotate Key
                </button> */}
                <button onClick={handleRevoke} disabled={!isActive} className="col-span-2 flex-1 text-[13px] font-semibold text-[#FFFFFF] bg-[#4B2364] py-2.5 rounded-[11px] border-none cursor-pointer transition-all disabled:opacity-40 disabled:cursor-not-allowed">
                  {isActive ? "Revoke Access" : "Revoked"}
                </button>
              </div>
            </div>

            {/* RIGHT */}
            <div className="flex flex-col gap-5">

              {/* Usage Card */}
              {/* <div className="bg-[#4B2364] rounded-[24px] p-8 flex flex-col gap-4">
                <div className="flex items-center gap-2">
                  <svg width="20" height="24" viewBox="0 0 24 24" fill="none" stroke="#FB923C" strokeWidth="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
                  <p className="text-[18px] font-bold text-white">API Usage</p>
                </div>
                <div className="grid grid-cols-3 gap-4">
                  <p className="text-[14px] text-white tracking-wider mb-1">Monthly Requests</p>
                  <p className="text-[14px] font-semibold text-white leading-tight">42,800 <span>/ 100,000</span></p>
                </div>
                <div>
                  <div className="w-full h-1.5 bg-[#FFFFFF1A] rounded-full overflow-hidden">
                    <div className="h-full rounded-full bg-gradient-to-r from-[#FB923C] to-[#FB923C00]" style={{ width: `${usage}%` }} />
                  </div>
                  <p className="text-[12px] Italic text-[#E9D5FF] mt-2">Refreshes in 12 days</p>
                </div>
                <div className="border-t border-white/10" />
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-[12px] text-[#E9D5FF] mb-0.5">Current Health</p>
                    <p className="text-[16px] font-semibold text-white">Excellent</p>
                  </div>
                  <div className="w-9 h-9 flex items-center justify-center">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#34D399" stroke="#34D399" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>
                  </div>
                </div>
              </div> */}

              {/* Resources */}
              <div className="bg-[#F3F4F5] rounded-[24px] p-8 flex flex-col gap-1">
                <p className="text-[14px] font-bold text-[#4C444E] uppercase tracking-widest mb-3">Resources</p>
                {[
                  { title: "API Documentation", sub: "Endpoints, schemas & examples", iconBg: "bg-[#FFFFFF] shadow-[0px_1px_2px_0px_#0000000D]", icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#34094D" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg> },
                 ].map((r, i, arr) => (
                  <div key={r.title}>
                    <div onClick={() => navigate("/api-docs")} className="flex items-center gap-3 py-3 cursor-pointer group">
                      <div className={`w-8 h-8 rounded-[12px] flex items-center justify-center shrink-0 ${r.iconBg}`}>{r.icon}</div>
                      <div className="flex-1 min-w-0">
                        <p className="text-[16px] font-bold text-[#191C1D] group-hover:text-[#6D28D9] transition-colors">{r.title}</p>
                        <p className="text-[12px] font-regular text-[#4C444E]">{r.sub}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Code Snippet */}
          {/* <div className="relative w-full rounded-[22px] overflow-hidden" style={{ background: "linear-gradient(135deg,#0F172A 0%,#020617 100%)", boxShadow: "0px 10px 30px rgba(0,0,0,0.25)" }}>
            <div className="absolute right-0 top-0 h-full flex items-center pr-8 pointer-events-none select-none" style={{ opacity: 0.06 }}>
              <svg width="180" height="180" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div className="relative z-10 px-7 py-6">
              <div className="flex items-center justify-between mb-5">
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-1.5">
                    <span className="w-3 h-3 rounded-full bg-[#EF4444] inline-block"/>
                    <span className="w-3 h-3 rounded-full bg-[#F59E0B] inline-block"/>
                    <span className="w-3 h-3 rounded-full bg-[#22C55E] inline-block"/>
                  </div>
                  <span className="text-[12px] text-[#9CA3AF] tracking-wide">Authentication Example (cURL)</span>
                </div>
                <button onClick={handleCopy} className="flex items-center gap-2 text-[12px] font-medium text-[#9CA3AF] hover:text-white bg-[#1E293B] hover:bg-[#334155] px-3.5 py-2 rounded-[10px] border-none cursor-pointer transition-all">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>
                  {copied ? "Copied!" : "Copy Code"}
                </button>
              </div>
              <pre className="text-[13px] leading-[1.8] font-mono overflow-x-auto" style={{ fontFamily: "'JetBrains Mono','Fira Code','Courier New',monospace" }}>
                <code>
                  <span className="text-[#F472B6]">curl</span><span className="text-[#E5E7EB]"> -X GET </span><span className="text-[#22D3EE]">"https://api.Krestapay.com/v1/balance"</span>{"\n"}
                  <span className="text-[#E5E7EB]">  -H </span><span className="text-[#FACC15]">"</span><span className="text-[#4ADE80]">Authorization</span><span className="text-[#E5E7EB]">: </span><span className="text-[#FACC15]">Bearer YOUR_API_KEY"</span>{"\n"}
                  <span className="text-[#E5E7EB]">  -H </span><span className="text-[#FACC15]">"</span><span className="text-[#4ADE80]">Content-Type</span><span className="text-[#E5E7EB]">: </span><span className="text-[#FACC15]">application/json"</span>
                </code>
              </pre>
            </div>
          </div> */}

        </div>
  );
}
